import React from 'react';

export const InsideRovodalContext: React.Context<boolean> = React.createContext<boolean>(false);
